
import { ProviderModule } from '@/store/modules/provider.module';
import { computed, defineComponent, provide, reactive, ref, watch } from 'vue';
import MultiLevel from '@/components/common/MultiLevel.vue'
import { AccountModule } from '@/store/modules/account.module';

export default defineComponent({
  props: {
    modelValue: {
      type: [Number, String],
      require: true
    },
    hadSunloginWeb: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MultiLevel
  },
  setup (props, ctx) {
    const searchKey = ref('')
    const selectedId = computed({
      get () {
        return props.modelValue
      },
      set (value) {
        ctx.emit('update:modelValue', value)
      }
    })
    provide('selectedId', selectedId)
    provide('changeSelectedId', function (val) {
      selectedId.value = val
    })

    const root = reactive({
      isRoot: true,
      active: true,
      name: ProviderModule.providerName,
      children: []
    });
    const showList = ref<Array<any>>([])

    const serviceDeskTreeList = computed(() => AccountModule.serviceDeskTreeListWidthKewword(searchKey.value))

    watch(serviceDeskTreeList, (val) => {
      root.children = val as any
      showList.value = [root]
    }, {
      immediate: true
    })

    function init () {
      if (AccountModule.serviceDeskList.length === 0) {
        // 查询全部状态
        AccountModule.loadServiceDeskList({ serviceDeskStatus: '0,1' })
      }
    }

    init()

    return {
      searchKey,
      root,
      selectedId,
      showList
    }
  }
})
